import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=1b0f55f4&scoped=true"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"
import style0 from "./NavigationBar.vue?vue&type=style&index=0&id=1b0f55f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0f55f4",
  null
  
)

export default component.exports